import { useState } from "react";

export const useForceUpdate = () => {
  const [, setState] = useState(false)
	return () => setState(val => !val)
}